const ACCOUNT_PUBLIC_PATHS = ['/account/login', '/account/signup', '/account/reset']

export type ProtectedAuthArea = 'account' | 'admin'

export function getProtectedAuthArea(pathname: string): ProtectedAuthArea | null {
  if (pathname.startsWith('/admin')) {
    return pathname === '/admin/login' || pathname.startsWith('/admin/login/')
      ? null
      : 'admin'
  }

  if (!pathname.startsWith('/account')) {
    return null
  }

  const isPublicAccountPath = ACCOUNT_PUBLIC_PATHS.some(
    publicPath => pathname === publicPath || pathname.startsWith(`${publicPath}/`)
  )

  return isPublicAccountPath ? null : 'account'
}
